<script>
import { mapState } from 'pinia';
import { basketStore } from '../../../stores/basket';
import { useEventBus } from '../../../stores/eventBus.js';
import BasketItem from '../basket/basket-item.vue';
import html2pdf from 'html2pdf.js';
import { Tools } from '../../../utils/tools.js';

export default {
	components: {
		BasketItem,
	},
	inject: ['catalogPageLocation'],
	computed: {
		...mapState(basketStore, {
			availableBasketItems: 'itemsAvailable',
			availableActiveBasketItems: 'itemsActiveAvailable',
			unavailableBasketItems: 'itemsUnavailable',
			basketSummary: 'summary'
		}),
		totalBasketPrice() {
			return this.formatNumber(this.basketSummary.totalPrice);
		}
	},

	mounted() {
		useEventBus().subscribe('o2k:basketStore:afterDataUpdate', this.basketUpdateHandler.bind(this));
	},

	methods: {
		basketUpdateHandler() {
			if (updateFavorites) {
				updateFavorites();
			}
		},
		formatNumber(num) {
			return Tools.formatPrice(num);
		},
		download() {
			const pdf = new html2pdf();
			const page = document.querySelector('.page');
			
			const pdfOptions = {
				filename: 'sov-obr-cart.pdf',
				margin: [10, 0],
				enableLinks: false,
				pagebreak: { mode: ['css'] },
				image: { type: 'png', quality: 1 },
				html2canvas: {
					scale: 2,
					onclone: function (doc) {
						doc.documentElement.querySelector('.page').classList.add('page--print');
					},
				},
				jsPDF: { format: 'A4' }
			};
			this.$refs.cartItemList.scrollTo(0, 0);
			this.$refs.cartItemList.style.maxHeight = 'fit-content';
			
			pdf.set(pdfOptions).from(page).save();
			
			this.$refs.cartItemList.style.removeProperty('max-height');
		},
		print() {
			window.print();
		}
	},
};
</script>

<template>
	<div class="cart-items">
		<div class="cart-items__list" ref="cartItemList">
			<BasketItem
				v-for="item in availableActiveBasketItems"
				:key="item.basketId"
				:basket-item="item"
			/>
		</div>
	</div>
	<div class="cart-items__footer">
		<div class="cart-items__controls">
			<button 
				class="button button--secondary button--pdf product-actions__download-button js-save-cart-to-pdf"
				@click="download"
			>
				<span>{{ $loc.get('BASKET_DOWNLOAD') }}</span>
			</button>
			<button 
				class="button button--secondary product-actions__print-button" 
				@click="print"
			>
				<span>{{ $loc.get('BASKET_PRINT') }}</span>
			</button>
		</div>
		<div class="cart-total">
			<div class="cart-total__count">
				{{ $loc.get('TOTAL') }} ({{ $loc.getPlural('BASKET_ITEM_TOTAL', basketSummary.productsCount, {'#COUNT#': basketSummary.productsCount}) }}):
			</div>
			<div class="cart-total__price">
				<span class="print-only">{{ $loc.get('TOTAL_PRINT') }}</span>
				<span v-html="totalBasketPrice"></span> <small>{{ $loc.get('CURRENCY') }}</small>
			</div>
		</div>
	</div>
</template>

<style scoped>

</style>
